import * as React from "react";

// Material UI
import { styled, alpha, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Button, Dialog, TextField, Typography } from "@mui/material";

// Material UI Icons
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
// Components

import FullScreenDropdown from "../Components/Common/fullScreenDropdown";
import ModeDropdown from "../Components/Common/modeDropdown";
import StoreSwitcher from "../Components/Common/StoreSwitcher";
import useStyles, { Colortheme } from "../pages/comman";
import { useAuth } from "../Routes/AuthProtected";

// MUI Style
const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const Header = (props: any) => {
  const theme = useTheme();
  const { logout } = useAuth();
  // Modal
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { cardBorder, cardbg } = Colortheme();
  const classes = useStyles();

  const handleLogout = () => {
    logout();
  };

  return (
    <React.Fragment>
      <Toolbar
        id="page-topbar"
        sx={{
          backgroundColor: cardbg,
          height: "70px",
          marginTop: "28px",
          borderBottom: "1px solid rgba(67, 142, 255, 0.1)",
        }}
      >
        {props.children}
        <IconButton
          color="default"
          size="large"
          edge="start"
          aria-label="open drawer"
          onClick={props.handleDrawerToggle}
        >
          {!props.open ? (
            theme.direction === "rtl" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )
          ) : (
            <MenuIcon />
          )}
        </IconButton>

        <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
          <StoreSwitcher />
        </Box>

        <Box sx={{ flexGrow: 1 }} />
        <Box>
          <Search sx={{ display: { sm: "flex", md: "none", margin: "0" } }}>
            <Button
              variant="text"
              size="small"
              startIcon={<SearchIcon />}
              sx={{ color: "text.secondary" }}
              onClick={handleOpen}
            />
          </Search>
        </Box>
        <FullScreenDropdown />
        <ModeDropdown />
        <Button
          onClick={handleLogout}
          sx={{
            backgroundColor: "primary.main",
            padding: "8px 24px",
            borderRadius: "8px",
            fontWeight: "bold",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#3b82f6",
            },
          }}
        >
          <KeyboardReturnIcon sx={{ mr: 1, color: "#fff" }} />
          Logout
        </Button>
      </Toolbar>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <Box
          className={classes.cardCommam}
          sx={{ borderColor: cardBorder, backgroundColor: cardbg }}
        >
          <Box
            className={classes.cardbody}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <TextField
              label="Search for Rudrix..."
              variant="outlined"
              fullWidth
              style={{ flex: 1 }}
            />
            <IconButton onClick={handleClose} sx={{ padding: "0" }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default Header;
